import type { ComponentPropI } from "@Common/types/resources";
import { FormComponent } from "@Src/resources/forms/FormComponent";
import { Edit } from "react-admin";

// Very important to provide empty default value
export const FormsEdit = (props: ComponentPropI) => {
	return (
		<Edit disableAuthentication={props.isPublic} mutationMode="pessimistic">
			<FormComponent type="edit" />
		</Edit>
	);
};
